import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'carbon-components-react'
import IconCheckMark from '../../../globals/images/icon-checkmark.svg'
import { MFA } from '../MFASteps'
import { MFADomain } from '../../domain/mfa.services'
import Container from '../../shared/container/Container'
import FactorOption from '../../shared/factorOption/FactorOption'
import PhoneIcon from '../../../globals/images/icon-phone.svg'
import EmailIcon from '../../../globals/images/icon-blue-email.svg'
import ConfirmationIcon from '../../../globals/images/icon-checkmark-header.svg'
import { trackEventMessage } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_SETUP_EMAIL, MFA_SETUP_SMS } from '../../../constants'

export const MFAConfirmationCode = ( { phoneNumber, onClose, email, factors, onSetUpClick, webId } ) => {
    
    const headerReference = useRef( null )

    const smsActive = MFADomain.IsFactorActive( factors, MFA.factorType.sms )
    const emailActive = MFADomain.IsFactorActive( factors, MFA.factorType.email )
    const updateProfilePageUrl = process.env.REACT_APP_EDIT_PROFILE

    const onHandleClose = ( event, redirectToProfilePage ) => {
        if( event ) event.preventDefault()

        if( redirectToProfilePage ) onClose( updateProfilePageUrl )
        else  onClose()
    }

    const onHandleSetup = ( factor ) => { 
        const factorMsg = factor == MFA.FACTORS.EMAIL ? MFA_SETUP_EMAIL.SEND_CODE : MFA_SETUP_SMS.SEND_CODE
        trackEventMessage( new EventModel( factorMsg, webId ) )
        onSetUpClick( factor )
    }
    
    useEffect( () => {
            headerReference?.current?.focus() 
    }, [] 
    )

  return ( <Container onClose ={ onHandleClose }>                
      <div className='mb-6'><img src={ ConfirmationIcon } height='32px' width='34px' alt='Icon' className='mr-4 display-inLine' /><header ref={ headerReference } tabIndex='0' className='c-mfa-label--title display-inLine' aria-label={ MFA.ConfirmationCode.title }>{ MFA.ConfirmationCode.title }</header></div>
      <div className='mb-5'><label tabIndex='0' className='c-mfa-label--content-gray60 display-inLine' aria-label={ MFA.ConfirmationCode.description }> { MFA.ConfirmationCode.description } </label><a id='dt-mfa-setupsuccessful-profile-page' className='mfa-app-link c-mfa-label--link-size2 display-inLine' href={ updateProfilePageUrl } onClick={ ( event ) => onHandleClose( event, true ) } >account profile page</a></div>
      <div className='mb-5'><label tabIndex='0' className='c-mfa-label--sub-title' aria-label={ MFA.ConfirmationCode.receiveVerificationsCodeVia }> { MFA.ConfirmationCode.receiveVerificationsCodeVia } </label></div>
      <div className='mb-6'>
          <>              
              { smsActive && <FactorOption img={ IconCheckMark } title= { phoneNumber } bold width='18' height='12' /> }
              { emailActive && <FactorOption img={ IconCheckMark } title= { email } bold width='18' height='12'  /> }              
          </>               
      </div>
      {  smsActive && emailActive  ? null : <div className='mb-8'> <div className='hr-line mb-6'></div>
          <div className='mb-6'>
              <label tabIndex='0' className='c-mfa-label--additional-option'>{ MFA.ChooseFactor.additionalOptions }</label>
          </div>
          { smsActive && <FactorOption setUpId='dt-mfa-setupsuccessful-email-setup' img={ EmailIcon } title= { MFA.ConfirmationCode.emailVerification } setupOption setupAriaDescription={ MFA.ConfirmationCode.emailSetupAriaDescription } onSetUpClick= { () => { onHandleSetup( MFA.FACTORS.EMAIL ) } }  /> }
          { emailActive && <FactorOption setUpId='dt-mfa-setupsuccessful-sms-setup' img={ PhoneIcon } title= { MFA.ConfirmationCode.textMessageVerification } setupOption  setupAriaDescription={ MFA.ConfirmationCode.smsSetupAriaDescription } onSetUpClick= { () => { onHandleSetup( MFA.FACTORS.SMS ) } } />  }  
      </div> }
      <div className='mb-6'>
          <Button id='dt-mfa-setupsuccessful-done' className={ 'c-btn c-btn c-btn--primary mb-5' } onClick={ () => onHandleClose( null, false ) } aria-label='Done enabled' name="close" type='button' data-testid="btn-close">{ MFA.done }</Button>
      </div>
  </Container>  
  )
}

MFAConfirmationCode.propTypes = {
    phoneNumber: PropTypes.string,
    returnUrl: PropTypes.string,
    onClose: PropTypes.func,
    email: PropTypes.string,
    factors: PropTypes.array,
    onSetUpClick: PropTypes.func,
    webId: PropTypes.string
  }